import React, {useEffect, useState} from 'react';
import {TreeSelect} from 'antd';
import ApiService from "../../core/service/api-service";
import {useTranslation} from "react-i18next";

const {TreeNode} = TreeSelect;

/**
 *
 * @param {{modalityId: number}} props
 */
export default function RequestTypeSelectBox(props)
{
    const {t} = useTranslation();
    const [data, setData] = useState([]);
    const [value, setValue] = useState(undefined);

    const getRequestGroupList = async () => {
        if(props.modalityId)
        {
            const response = await ApiService.RequestType.GetByModality(props.modalityId)
            if(response.success)
            {
                setData(response.data)
            }
        }
        else
        {
            const response = await ApiService.RequestType.GetList()
            if(response.success)
            {
                setData(response.data)
            }
        }
    }

    const onChange = () =>
    {
        setValue(value);
    };

    useEffect(() => {
        getRequestGroupList()
    }, [props.modalityId])

    return (
        <TreeSelect
            showSearch
            style={{width: '100%'}}
            value={value}
            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
            placeholder={t("Please select")}
            allowClear
            treeDefaultExpandAll
            onChange={onChange}
            filterTreeNode={(val, item) => {
                return item.title.toLowerCase().includes(val)
            }}
            {...props}
        >
            {
                data.map(type => {
                    return (
                        <TreeNode key={type.id} value={type.id} title={type.name} />
                    )
                })
            }
        </TreeSelect>
    );
}
